import React from 'react';
import Link from 'components/Link';
import AdCaller from 'helpers/ads/adCaller';
import s from './CardV5.scss';

class CardV5 extends React.Component {
  render() {
    const { data, datanewga, ga4Type, ga4Category } = this.props;
    return (
      <>
        {data &&
          data.hl &&
          !data.logoUrl && (
            <Link
              to={data.wu}
              className={s.cardv5}
              target="_blank"
              data-newga={`${datanewga}#${data.wu}`}
              ga4Data={
                ga4Type && [
                  {
                    event: 'user_click',
                    type: `${ga4Type}`,
                    category: `${ga4Category || 'story_click'}`,
                    msid: data?.id,
                    label: data?.logotext,
                  },
                ]
              }
            >
              <h3 className={s.topRow}>
                <span
                  className={`${s.brand_logo} ${!data.imageid ? s.noLogo : ''}`}
                  title={data.logotext}
                >
                  {data.logotext}
                </span>{' '}
                {data &&
                  data.imageid && (
                    <>
                      <span>/</span>
                      <img
                        src={`https://static.toiimg.com/photo/imgsize-${
                          data.imagesize ? data.imagesize : '120'
                        },msid-${data.imageid},resizemode-4/${
                          data.imageid
                          }.jpg`}
                        alt=""
                      />
                    </>
                  )}
              </h3>
              <p>{data.hl}</p>
            </Link>
          )}

        {data &&
          data.hl &&
          data.logoUrl &&
          data.logoUrl !== '' && (
            <div className={s.cardv5}>
              <h3 className={s.topRow}>
                <span className={s.brand_logo} title={data.logotext}>
                  <Link
                    to={data.wu}
                    target="_blank"
                    data-newga={`${datanewga}#${data.wu}`}
                    ga4Data={
                      ga4Type && [
                        {
                          event: 'user_click',
                          type: `${ga4Type}`,
                          category: `${ga4Category || 'story_click'}`,
                          msid: data?.id,
                          label: data?.logotext,
                        },
                      ]
                    }
                  >
                    {data.logotext}
                  </Link>
                </span>{' '}
                {data &&
                  data.imageid &&
                  !data.adName && (
                    <div>
                      <span>/</span>
                      <Link
                        to={data.logoUrl}
                        target="_blank"
                        data-newga={`${datanewga}#${data.logoUrl}`}
                        ga4Data={
                          ga4Type && [
                            {
                              event: 'user_click',
                              type: `${ga4Type}`,
                              label: data?.logoUrl,
                            },
                          ]
                        }
                      >
                        <img
                          src={`https://static.toiimg.com/photo/imgsize-${
                            data.imagesize ? data.imagesize : '120'
                          },msid-${data.imageid},resizemode-4/${
                            data.imageid
                            }.jpg`}
                          alt=""
                        />
                      </Link>
                    </div>
                  )}
                {data?.adName && (
                  <AdCaller immediateLoad data={{ jname: data.adName }} />
                )}
              </h3>
              <p>
                <Link
                  to={data.wu}
                  target="_blank"
                  data-newga={`${datanewga}#${data.wu}`}
                >
                  {data.hl}
                </Link>
              </p>
            </div>
          )}
      </>
    );
  }
}

export default CardV5;
